module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Just in: small batch of Jamaican Blue Mountain in store next week"}}},{"node":{"fields":{"slug":"/blog/2016-12-17-making-sense-of-the-scaas-new-flavor-wheel/"},"frontmatter":{"title":"Making sense of the SCAA’s new Flavor Wheel"}}}]}},"pathContext":{"tag":"tasting"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-tasting.json
// module id = 364
// module chunks = 71381831944032